import React from "react";

import {
  Box,
  Radio as MuiRadio,
  RadioProps,
  Stack,
  StackProps,
} from "@mui/material";

const RadioIcon = ({ children }: StackProps) => {
  return (
    <Stack
      component="span"
      justifyContent="center"
      alignItems="center"
      sx={{
        borderRadius: "50%",
        width: "24px",
        height: "24px",
        boxShadow: "inset 0px 2px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      {children}
    </Stack>
  );
};

const RadioCheckedIcon = () => {
  return (
    <RadioIcon>
      <Box
        component="span"
        sx={{
          borderRadius: "50%",
          "@keyframes grow": {
            "0%": {
              width: "6px",
              height: "6px",
            },
            "100%": {
              width: "12px",
              height: "12px",
            },
          },
          animation: "grow 0.05s ease-out",
          animationFillMode: "forwards",
          backgroundColor: "shades.neutral.900",
        }}
      />
    </RadioIcon>
  );
};

const Radio = ({ sx, ...props }: RadioProps) => {
  return (
    <MuiRadio
      disableRipple
      color="default"
      icon={<RadioIcon />}
      checkedIcon={<RadioCheckedIcon />}
      sx={{
        "input:disabled ~ span": {
          bgcolor: "shades.neutral.50", // bgcolor of input
          "& span": {
            bgcolor: "shades.neutral.200", // bgcolor of checked icon
          },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default Radio;
